import { Observable, Subject } from 'rxjs';

import Entity from '../entity';
import { SelectionEvent } from './selection_event';

export default abstract class SelectionEventProvider<
  T extends SelectionEvent<Entity<unknown>>,
> {
  eventsSubject = new Subject<T>();

  get events$(): Observable<T> {
    return this.eventsSubject.asObservable();
  }

  dispatch(event: T) {
    this.eventsSubject.next(event);
  }
}
